export default "__VITE_PUBLIC_ASSET__5d5501ff__"